export default __webpack_public_path__ + "static/media/dse.3b12f431.webp";